import { atom } from 'jotai';

import { AddressFieldType } from '@restworld/data-services';

// The venue onboarding state lives here, apart from the modal in `index.tsx`, so that the org
// onboarding atoms (read by the /getting-started page shell) can import it without pulling the
// whole modal, its form and its footer into the page's first chunk. `index.tsx` re-exports
// everything, so existing imports keep working and share the same atom instances.

export type RestaurantOnboardingStage =
  | 'intro'
  | 'select_restaurant_from_google'
  | 'magic_ai_loading'
  | 'restaurant_onboarding_form'
  | 'restaurant_owner_onboarding_form'
  | 'restaurant_onboarding_successfull'
  | 'restaurant_already_exists'
  | 'contact_already_exists'
  | 'otp_verification'
  | 'not_horeca';

export const activeRestaurantOnboardingStateAtom = atom<RestaurantOnboardingStage>('select_restaurant_from_google');
export const restaurantOnboardingModalVisibleAtom = atom(false);
export const isManualEntryAtom = atom(false);
export const manualAddressFieldsAtom = atom<Partial<AddressFieldType>>({});
// Latest Google Places `status` observed (OK, ZERO_RESULTS, OVER_QUERY_LIMIT, REQUEST_DENIED,
// INVALID_REQUEST, UNKNOWN_ERROR, NOT_FOUND, ...). Empty string means no status seen yet.
// (Using an empty-string sentinel rather than `null` because this tsconfig has
// `strict: false`, which makes `atom<string | null>(null)` resolve to the read-only overload.)
export const googlePlacesLastStatusAtom = atom('');
// Set to true when an `employer_onboarding_google_search_no_result` event was emitted
// during the current restaurant-creation step session. Read at manual form submit to
// fill `had_prior_no_result`.
export const googleSearchNoResultSeenAtom = atom(false);
